define("preview-grid/templates/media-item", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet — Shared::MediaItemModal is not yet Glint-registered }}
  <Shared::MediaItemModal
    @account={{this.currentAccount}}
    @canCreatePost={{this.canCreatePost}}
    @cancelEditingCaption={{this.cancelEditingCaption}}
    @close={{this.canClose}}
    @createPostText={{this.createPostText}}
    @editCaption={{this.editCaption}}
    @editPost={{this.editPost}}
    @editingCaption={{this.editingCaption}}
    @hasDirtyAttributes={{this.hasDirtyAttributes}}
    @hasLabels={{this.hasLabels}}
    @hasSecondary={{this.hasSecondary}}
    @isMediaEditRouteExternal={{true}}
    @location="clicked_side_library_button_by_visual_planner"
    @mediaItem={{this.model}}
    @model={{this.model}}
    @postElementId={{this.uniqueId}}
    @rejectCreatePostReason={{this.rejectCreatePostReason}}
    @rollbackSavedCaption={{this.rollbackSavedCaption}}
    @route="cluster.schedule.preview-grid.media"
    @saveEditedCaption={{this.saveEditedCaption}}
    @savedCaptionToEdit={{this.savedCaptionToEdit}}
    @setCaptionToEdit={{set this "savedCaptionToEdit"}}
    @showUpgradeButton={{this.showUpgradeButton}}
    @socialProfile={{this.socialProfile}}
    @toggleCaptionTemplate={{this.toggleCaptionTemplate}}
    @toggleSecondary={{this.toggleSecondary}}
    @toggleSmartHashtags={{this.toggleSmartHashtags}}
  />
  */
  {
    "id": "+sDOB/6O",
    "block": "[[[8,[39,0],null,[[\"@account\",\"@canCreatePost\",\"@cancelEditingCaption\",\"@close\",\"@createPostText\",\"@editCaption\",\"@editPost\",\"@editingCaption\",\"@hasDirtyAttributes\",\"@hasLabels\",\"@hasSecondary\",\"@isMediaEditRouteExternal\",\"@location\",\"@mediaItem\",\"@model\",\"@postElementId\",\"@rejectCreatePostReason\",\"@rollbackSavedCaption\",\"@route\",\"@saveEditedCaption\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@showUpgradeButton\",\"@socialProfile\",\"@toggleCaptionTemplate\",\"@toggleSecondary\",\"@toggleSmartHashtags\"],[[30,0,[\"currentAccount\"]],[30,0,[\"canCreatePost\"]],[30,0,[\"cancelEditingCaption\"]],[30,0,[\"canClose\"]],[30,0,[\"createPostText\"]],[30,0,[\"editCaption\"]],[30,0,[\"editPost\"]],[30,0,[\"editingCaption\"]],[30,0,[\"hasDirtyAttributes\"]],[30,0,[\"hasLabels\"]],[30,0,[\"hasSecondary\"]],true,\"clicked_side_library_button_by_visual_planner\",[30,0,[\"model\"]],[30,0,[\"model\"]],[30,0,[\"uniqueId\"]],[30,0,[\"rejectCreatePostReason\"]],[30,0,[\"rollbackSavedCaption\"]],\"cluster.schedule.preview-grid.media\",[30,0,[\"saveEditedCaption\"]],[30,0,[\"savedCaptionToEdit\"]],[28,[37,1],[[30,0],\"savedCaptionToEdit\"],null],[30,0,[\"showUpgradeButton\"]],[30,0,[\"socialProfile\"]],[30,0,[\"toggleCaptionTemplate\"]],[30,0,[\"toggleSecondary\"]],[30,0,[\"toggleSmartHashtags\"]]]],null]],[],false,[\"shared/media-item-modal\",\"set\"]]",
    "moduleName": "preview-grid/templates/media-item.hbs",
    "isStrictMode": false
  });
});